/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSoldHeader_item = {
    readonly title: string | null;
    readonly " $refType": "PdpSharedSoldHeader_item";
};
export type PdpSharedSoldHeader_item$data = PdpSharedSoldHeader_item;
export type PdpSharedSoldHeader_item$key = {
    readonly " $data"?: PdpSharedSoldHeader_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedSoldHeader_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSoldHeader_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'c0c9b105f2020f354db053081c15af1d';
export default node;
